(() => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) entry.target.classList.add("is-visible");
    });
  }, { threshold: 0.18 });

  document.querySelectorAll("[data-animate]").forEach((el) => io.observe(el));
  const mobileNavToggle = document.querySelector("[data-mobile-nav-toggle]");
  const mobileNav = document.querySelector("[data-mobile-nav]");
  if (mobileNavToggle && mobileNav) {
    let isClosingMobileNav = false;
    const syncMobileNav = (open) => {
      if (open) {
        isClosingMobileNav = false;
        mobileNav.hidden = false;
        requestAnimationFrame(() => {
          mobileNav.classList.add("is-open");
        });
        mobileNavToggle.setAttribute("aria-expanded", "true");
        document.body.classList.add("mobile-nav-open");
        return;
      }

      if (mobileNav.hidden || isClosingMobileNav) return;
      isClosingMobileNav = true;
      mobileNav.classList.remove("is-open");
      mobileNavToggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("mobile-nav-open");
      window.setTimeout(() => {
        if (!mobileNav.classList.contains("is-open")) {
          mobileNav.hidden = true;
        }
        isClosingMobileNav = false;
      }, 240);
    };

    mobileNavToggle.addEventListener("click", () => {
      const open = mobileNavToggle.getAttribute("aria-expanded") !== "true";
      syncMobileNav(open);
    });

    mobileNav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => syncMobileNav(false));
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") syncMobileNav(false);
    });
  }

  const announcementBar = document.querySelector("[data-announcement-bar]");
  if (announcementBar) {
    const closeBtn = announcementBar.querySelector("[data-announcement-close]");
    const keyBase = announcementBar.dataset.announcementKey || "default";
    const storageKey = `stacked-announcement-dismissed-${keyBase}`;

    try {
      if (window.localStorage.getItem(storageKey) === "1") {
        announcementBar.remove();
      }
    } catch (err) {
      // Ignore storage errors (private mode, blocked storage, etc.)
    }

    closeBtn?.addEventListener("click", () => {
      announcementBar.remove();
      try {
        window.localStorage.setItem(storageKey, "1");
      } catch (err) {
        // Ignore storage errors.
      }
    });
  }

  if (!prefersReducedMotion) {
    [".flavors-scroll .flavor-card", ".reviews-scroll .review-card", ".highlights-strip .highlight-badge"].forEach((selector) => {
      document.querySelectorAll(selector).forEach((el, index) => {
        el.style.transitionDelay = `${Math.min(index * 60, 240)}ms`;
      });
    });
  }

  const stickyWrap = document.querySelector("[data-sticky-atc]");
  const productForm = document.querySelector("[data-main-product-form]");
  if (stickyWrap && productForm) {
    const addBtn = productForm.querySelector("button[type='submit']");
    const qtyInput = productForm.querySelector("input[name='quantity']");
    const stickyBtn = stickyWrap.querySelector("[data-sticky-atc-label]");
    const stickyQty = stickyWrap.querySelector("[data-sticky-qty-input]");
    const mainPrice = document.querySelector("[data-main-price]");
    const stickyPriceLabel = stickyWrap.querySelector("[data-sticky-atc-label]");

    if (stickyQty && qtyInput) {
      stickyQty.value = qtyInput.value || 1;
      stickyQty.addEventListener("input", () => {
        qtyInput.value = stickyQty.value || 1;
      });
      qtyInput.addEventListener("input", () => {
        stickyQty.value = qtyInput.value || 1;
      });
    }

    stickyBtn?.addEventListener("click", () => addBtn?.click());

    const mainMinus = productForm.querySelector("[data-qty-minus]");
    const mainPlus = productForm.querySelector("[data-qty-plus]");
    mainMinus?.addEventListener("click", () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    });
    mainPlus?.addEventListener("click", () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) + 1));
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    });

    const stickyMinus = stickyWrap.querySelector("[data-sticky-qty-minus]");
    const stickyPlus = stickyWrap.querySelector("[data-sticky-qty-plus]");
    stickyMinus?.addEventListener("click", () => {
      if (!stickyQty) return;
      stickyQty.value = String(Math.max(1, Number(stickyQty.value || 1) - 1));
      stickyQty.dispatchEvent(new Event("input", { bubbles: true }));
    });
    stickyPlus?.addEventListener("click", () => {
      if (!stickyQty) return;
      stickyQty.value = String(Math.max(1, Number(stickyQty.value || 1) + 1));
      stickyQty.dispatchEvent(new Event("input", { bubbles: true }));
    });

    productForm.addEventListener("change", (event) => {
      if (event.target.name !== "id") return;
      const checked = productForm.querySelector("input[name='id']:checked");
      const price = checked?.dataset.price;
      if (!price) return;
      if (mainPrice) mainPrice.textContent = price;
      if (stickyPriceLabel) stickyPriceLabel.textContent = `Add To Cart - ${price}`;
    });

    const formObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyWrap.classList.toggle("is-visible", !entry.isIntersecting);
      });
    }, { threshold: 0.5 });

    formObserver.observe(addBtn || productForm);
  }

  document.querySelectorAll("[data-description-block]").forEach((block) => {
    const textEl = block.querySelector("[data-description-text]");
    const toggle = block.querySelector("[data-description-toggle]");
    if (!textEl || !toggle) return;
    toggle.addEventListener("click", () => {
      const expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", expanded ? "false" : "true");
      textEl.classList.toggle("is-collapsed", expanded);
      toggle.textContent = expanded ? "Show More" : "Show Less";
    });
  });

  document.querySelectorAll("[data-product-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-carousel-track]");
    const slides = carousel.querySelectorAll("[data-carousel-slide]");
    const prev = carousel.querySelector("[data-carousel-prev]");
    const next = carousel.querySelector("[data-carousel-next]");
    const dotsWrap = carousel.querySelector("[data-carousel-dots]");
    if (!track || slides.length <= 1) {
      if (prev) prev.style.display = "none";
      if (next) next.style.display = "none";
      return;
    }

    let index = 0;
    const dots = Array.from(slides).map((_, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.setAttribute("aria-label", `Go to image ${i + 1}`);
      btn.addEventListener("click", () => {
        index = i;
        sync();
      });
      dotsWrap?.appendChild(btn);
      return btn;
    });

    const sync = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
      track.style.transition = "transform .36s ease";
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
    };

    prev?.addEventListener("click", () => {
      index = index === 0 ? slides.length - 1 : index - 1;
      sync();
    });
    next?.addEventListener("click", () => {
      index = index === slides.length - 1 ? 0 : index + 1;
      sync();
    });

    sync();
  });

  document.querySelectorAll("[data-featured-form]").forEach((form) => {
    form.addEventListener("change", (event) => {
      if (event.target.name !== "id") return;
      const checked = form.querySelector("input[name='id']:checked");
      const price = checked?.dataset.price;
      const target = form.querySelector("[data-featured-price]");
      if (price && target) target.textContent = price;
    });
  });

  document.querySelectorAll("[data-bundle-builder]").forEach((builder) => {
    const qtyInputs = builder.querySelectorAll("input[data-bundle-qty]");
    const totalEl = builder.querySelector("[data-bundle-total]");
    const helperEl = builder.querySelector("[data-bundle-helper]");
    const selectedEl = builder.querySelector("[data-bundle-selected]");
    const submitBtn = builder.querySelector("[data-bundle-submit]");
    const bundleSize = Number(builder.dataset.bundleSize || "12");
    const maxPerFlavor = Number(builder.dataset.maxPerFlavor || "12");
    const form = builder.querySelector("form");

    const syncTotal = () => {
      const rows = Array.from(qtyInputs);
      const totalQty = rows.reduce((sum, input) => sum + Number(input.value || 0), 0);
      const totalCents = rows.reduce((sum, input) => sum + (Number(input.value || 0) * Number(input.dataset.price || 0)), 0);
      totalEl.textContent = (totalCents / 100).toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
      });
      if (selectedEl) selectedEl.textContent = String(totalQty);
      if (helperEl) {
        if (totalQty < bundleSize) {
          helperEl.textContent = `Choose ${bundleSize - totalQty} more snacks.`;
        } else if (totalQty > bundleSize) {
          helperEl.textContent = `Remove ${totalQty - bundleSize} snacks to match bundle size.`;
        } else {
          helperEl.textContent = "Bundle is ready to add to cart.";
        }
      }
      if (submitBtn) submitBtn.disabled = totalQty !== bundleSize;
    };

    builder.querySelectorAll("[data-bundle-plus]").forEach((button) => {
      button.addEventListener("click", () => {
        const input = button.parentElement?.querySelector("[data-bundle-qty]");
        if (!input) return;
        input.value = String(Math.min(maxPerFlavor, Number(input.value || 0) + 1));
        syncTotal();
      });
    });

    builder.querySelectorAll("[data-bundle-minus]").forEach((button) => {
      button.addEventListener("click", () => {
        const input = button.parentElement?.querySelector("[data-bundle-qty]");
        if (!input) return;
        input.value = String(Math.max(0, Number(input.value || 0) - 1));
        syncTotal();
      });
    });

    syncTotal();

    qtyInputs.forEach((input) => {
      input.addEventListener("input", () => {
        const next = Math.max(0, Math.min(maxPerFlavor, Number(input.value || 0)));
        input.value = String(next);
        syncTotal();
      });
    });

    form?.addEventListener("submit", (event) => {
      const selected = Array.from(qtyInputs).filter((i) => Number(i.value || 0) > 0);
      const totalQty = selected.reduce((sum, input) => sum + Number(input.value || 0), 0);
      if (totalQty !== bundleSize) {
        event.preventDefault();
        alert(`Please select exactly ${bundleSize} snacks.`);
        return;
      }

      form.querySelectorAll("input[data-generated-item='true']").forEach((node) => node.remove());
      selected.forEach((input, index) => {
        const idInput = document.createElement("input");
        idInput.type = "hidden";
        idInput.name = `items[${index}][id]`;
        idInput.value = input.dataset.variantId;
        idInput.setAttribute("data-generated-item", "true");

        const qtyInput = document.createElement("input");
        qtyInput.type = "hidden";
        qtyInput.name = `items[${index}][quantity]`;
        qtyInput.value = String(Number(input.value || 0));
        qtyInput.setAttribute("data-generated-item", "true");

        form.appendChild(idInput);
        form.appendChild(qtyInput);
      });
    });
  });

  const modalOpenButtons = document.querySelectorAll("[data-newsletter-modal-open]");
  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove("modal-open");
  };
  const openModal = (modal) => {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add("modal-open");
  };

  modalOpenButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const target = button.dataset.target;
      if (!target) return;
      const modal = document.getElementById(target);
      openModal(modal);
    });
  });

  document.querySelectorAll("[data-newsletter-modal-close]").forEach((button) => {
    button.addEventListener("click", () => {
      closeModal(button.closest(".stack-modal"));
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const open = document.querySelector(".stack-modal:not([hidden])");
    if (open) closeModal(open);
  });
})();
